import { PropsWithChildren, ReactElement, useMemo, useState } from 'react';

import { ViewWrapperNewContext, ViewWrapperNewProps } from './ViewWrapperNew.context.ts';

type Props<MODEL extends object> = PropsWithChildren & {
  contextObject: MODEL;
};

export const ViewWrapperNewContextProvider = <MODEL extends object>(
  props: Props<MODEL>,
): ReactElement<Props<MODEL>> => {
  const [contextObject, setContextObject] = useState<MODEL>(props.contextObject);

  const context: ViewWrapperNewProps<MODEL> = useMemo(() => {
    return {
      contextObject,
      setContextObject,
    };
  }, [contextObject]);

  return (
    // @ts-expect-error: no worries
    <ViewWrapperNewContext.Provider value={context}>
      {props.children}
    </ViewWrapperNewContext.Provider>
  );
};
